import { useEffect } from "react";

const upsertMeta = (name, content, attr = "name") => {
  let el = document.querySelector(`meta[${attr}="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

const upsertJsonLd = (id, json) => {
  let el = document.getElementById(id);
  if (!el) {
    el = document.createElement("script");
    el.type = "application/ld+json";
    el.id = id;
    document.head.appendChild(el);
  }
  el.textContent = JSON.stringify(json);
};

export const SEO = ({ title, description, jsonLd, jsonLdId = "page-jsonld" }) => {
  useEffect(() => {
    if (title) document.title = title;
    if (description) {
      upsertMeta("description", description);
      upsertMeta("og:description", description, "property");
    }
    if (title) {
      upsertMeta("og:title", title, "property");
    }
    if (jsonLd) {
      upsertJsonLd(jsonLdId, jsonLd);
    }
  }, [title, description, jsonLd, jsonLdId]);
  return null;
};
